export const Sheet5 = {

    rangoKm: [
        { orden: 1, Rango: 'De 0 a 10', De: 0, Hasta: 10 },
        { orden: 2, Rango: 'De 10 a 20', De: 10.01, Hasta: 20 },
        { orden: 3, Rango: 'De 20 a 50', De: 20.01, Hasta: 50 },
        { orden: 4, Rango: 'Mayor a 50', De: 50.01, Hasta: 2000 }
    ],
    rangoMontos: [
        { orden: 1, Rango: 'De 0 a 5', De: 0, Hasta: 5000000 },
        { orden: 2, Rango: 'De 5 a 20 ', De: 5000001, Hasta: 20000000 },
        { orden: 3, Rango: 'De 20 a 50', De: 20000001, Hasta: 50000000 },
        { orden: 4, Rango: 'Mayor a 50', De: 50000001, Hasta: 5000000000 }
    ],
    rangoPlazo: [
        { orden: 1, Rango: 'De 0 a 13', De: 0, Hasta: 13 },
        { orden: 2, Rango: 'De 13 a 19', De: 13.01, Hasta: 19 },
        { orden: 3, Rango: 'De 19 a 24', De: 19.01, Hasta: 24 },
        { orden: 4, Rango: 'Mayor a 24', De: 24.01, Hasta: 5000 }
    ],
    rangoSobreplazo: [
        { orden: 1, Rango: 'De 0% a 15%', De: 0, Hasta: 0.15 },
        { orden: 2, Rango: 'De 15% a 25%', De: 0.151, Hasta: 0.25 },
        { orden: 3, Rango: 'De 25% a 50%', De: 0.251, Hasta: 0.5 },
        { orden: 4, Rango: 'Más de 50%', De: 0.51, Hasta: 5 }
    ],
    rangoSobrecosto: [
        { orden: 1, Rango: 'De 0% a 15%', De: 0, Hasta: 0.15 },
        { orden: 2, Rango: 'De 15% a 25%', De: 0.151, Hasta: 0.25 },
        { orden: 3, Rango: 'De 25% a 50%', De: 0.251, Hasta: 0.5 },
        { orden: 4, Rango: 'Más de 50%', De: 0.51, Hasta: 5 }
    ],
    rangoSobrecostoNotaFinal: [
        { orden: 1, Rango: 'Menor a 30%', De: 0, Hasta: 0.3 },
        { orden: 2, Rango: 'De 30% a 50%', De: 0.30001, Hasta: 0.5 },
        { orden: 3, Rango: 'Mayor a 50%', De: 0.5000001}
    ],
    rangoSobreplazoNotaFinal: [
        { orden: 1, Rango: 'Menor a 30%', De: 0, Hasta: 0.3 },
        { orden: 2, Rango: 'De 30% a 50%', De: 0.30001, Hasta: 0.5 },
        { orden: 3, Rango: 'Mayor a 50%', De: 0.5000001}
    ],

}